module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.flag == 0) ? _c('default-header') : _vm._e(), _vm._v(" "), (_vm.flag == 1) ? _c('cei-app-header') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb74833a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 1098
// module chunks = 284